module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/minus-160c5562364d605f36401743738bef4e.svg";